import { getProvider } from '../svpProvider';

import { requestSVP } from './shared/requestSVP';

import type { SvpCategory } from '../../types';

export async function fetchCategories(
  params: Record<string, string> = {},
  signal?: AbortSignal
) {
  const json = await requestSVP<{
    _embedded: { categories: SvpCategory[] };
  }>({
    provider: getProvider(),
    path: '/categories',
    params: {
      ...params,
      additional: 'true',
    },
    signal,
  });

  return json._embedded ? json._embedded.categories : [];
}

export async function fetchCategoryById(
  categoryId: number,
  signal?: AbortSignal
) {
  return await requestSVP<SvpCategory>({
    provider: getProvider(),
    path: `/categories/${categoryId}`,
    params: { additional: 'true' },
    signal,
  });
}
